/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import debounce from "lodash/debounce";
import { useSelector, useDispatch } from "react-redux";
import {
  addSingleDestinationFormToState,
  addMultipleDestinationFormToState,
  addAirportFormToState,
  addByTheHourFormToState,
} from "../../../actions/admin/booking";
import PassengerCard from "../cards/PassengerCard";
import { useHistory, useLocation } from "react-router-dom";
import {
  getTotalPaxCount,
  getTotalLuggageCount,
} from "../../../utils/Calculator";
import { useTranslation } from "react-i18next";
import Select from "react-select";

import { getRouteCarForTotalTime } from "../../../actions/navitimeAPI";
import {
  registerLocale,
} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/ja";
import ja from "date-fns/locale/ja";
import CustomGoogleAutoComplete from "../../../components/layout-new-theme/google-input/CustomGoogleAutoComplete";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import {
  AnimatedSelectIndicator,
  AnimatedSelectMenu,
  LuxurySelectOption,
  ButtonLoadingSwap,
  FieldError,
  searchButtonMotionProps,
} from "./formMotion";
import AnimatedDatePicker from "./AnimatedDatePicker";
import { travelAreaOptions } from "../../../utils/dataLists";
import { pushEventGTM } from "../../../utils/gtm";
import {
  PaxIcon,
  LuggageIcon,
  ArrowRightIcon,
  LocationPinIcon,
  ClockIcon,
  CalendarIcon,
} from "../../icons";
import { cn } from "../../../utils/classnames";
import { BROWSER_AUTOFILL_OFF } from "../../../utils/autofill";

const ByTheHourForm = ({
  byTheHourForm = null,
  checkByTheHourFormAvailableVehicle,
  availabilityValueReset,
  formValidationData,
  isLoading = null,
}) => {
  const { t, i18n } = useTranslation();
  const shouldReduceMotion = useReducedMotion();
  let history = useHistory();
  const search = useLocation();
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const [passengerVisible, setPassangeVisible] = useState(false);
  const [lugageVisible, setLugageVisible] = useState(false);
  const [pickuplocation, setpickuplocation] = useState();
  const [dropofflocations, setdropofflocations] = useState([]);
  const [halfHourIntervalsData, setHalfHourIntervalsData] = useState([]);
  const [totalPax, setTotalPax] = useState(0);
  const [totalLugage, setTotalLugage] = useState(0);
  const [formatedTravelDate, setFormatedTravelDate] = useState("");
  const [travelDatePicker, setTravelDatePicker] = useState(new Date());
  const [byTheHourFormData, setByTheHourFormData] = useState({
    pickuplocation: "",
    dropofflocations: [],
    traveldate: "",
    pickuptime: "",
    dropofftime: "",
    pax: null,
    lugage: {
      checkinSize: 0,
      cabinSize: 0,
    },
    duration: "",
    byTheHourBook: true,
    travelArea: "",
  });
  const [byTheHourStationAndAirport, setByTheHourStationAndAirport] = useState({
    isAirportTransfer: false,
    isFromAirport: false,
    isToAirport: false,
    isStationTransfer: false,
    isFromStation: false,
    isToStation: false,
  })
  const settings = useSelector((state) => state.setting);
  const [changeLuggage, setChangeLuggage] = useState(byTheHourForm !== null ? true : false);
  const { lang } = settings;
  const [formDataValidation, setformDataValidation] = useState(formValidationData);
  const [dropOffTimeToShow, setDropOffTimeToShow] = useState("");
  const [changeTravelArea, setChangeTravelArea] = useState(false);

  if (lang?.toUpperCase() === "EN" || lang?.toUpperCase() === "en") {
    moment.locale("en");
  } else {
    moment.locale("ja");
  }

  registerLocale("ja", ja);

  const dateFormat = {
    "EN": "MMM D, yyyy (ddd)",
    "JP": "YYYY年M月D日（ddd）",
    "en": "MMM D, yyyy (ddd)",
    "jp": "YYYY年M月D日（ddd）"
  }

  useEffect(() => {
    if (byTheHourForm === null) return;
    setpickuplocation(byTheHourForm.pickuplocation);
    setdropofflocations(byTheHourForm.dropofflocations);
    setTotalPaxValues(byTheHourForm.pax);
    setTotalLugageValues(byTheHourForm.lugage);
    const sfdObj = byTheHourFormData;
    sfdObj.pickuplocation = byTheHourForm.pickuplocation;
    sfdObj.dropofflocations = byTheHourForm.dropofflocations;
    sfdObj.traveldate = byTheHourForm.traveldate;
    sfdObj.pickuptime = byTheHourForm.pickuptime;
    sfdObj.dropofftime = byTheHourForm.dropofftime;
    sfdObj.pax = byTheHourForm.pax;
    sfdObj.lugage = byTheHourForm.lugage;
    sfdObj.duration = byTheHourForm.duration;
    sfdObj.travelArea = byTheHourForm.travelArea;

    setByTheHourStationAndAirport({
      isAirportTransfer: byTheHourForm.isAirportTransfer,
      isFromAirport: byTheHourForm.isFromAirport,
      isToAirport: byTheHourForm.isToAirport,
      isStationTransfer: byTheHourForm.isStationTransfer,
      isFromStation: byTheHourForm.isFromStation,
      isToStation: byTheHourForm.isToStation,
    })

    if (byTheHourForm.travelArea !== null) {
      setChangeTravelArea(true);
    }

    if (
      byTheHourFormData.traveldate !== null ||
      byTheHourFormData.traveldate !== ""
    ) {
      setTravelDatePicker(new Date(byTheHourFormData.traveldate));
      setFormatedTravelDate(byTheHourFormData.traveldate);
    }

    if (
      byTheHourForm.dropofflocations.length !== 0 &&
      byTheHourForm.pickuplocation !== ""
    ) {
      checkTotalTime(byTheHourForm);
    }
  }, []);

  useEffect(() => {
    setformDataValidation(formValidationData);
  }, [formValidationData]);

  const setPaxAndLuggaePannalVisibility = (status) => {
    setPassangeVisible(status);
    setLugageVisible(status);
  };

  const searchAvailableVehicles = async () => {
    const st = setFormValidationValues();

    if (st) {
      if (search.pathname === "/" || search.pathname === "/en/" || search.pathname === "/jp/") {
        setByTheHourForm();
      } else {
        const sfdObj = byTheHourFormData;
        sfdObj.pickuplocation = pickuplocation;
        sfdObj.dropofflocations = dropofflocations;
        sfdObj.isAirportTransfer = byTheHourStationAndAirport.isAirportTransfer;
        sfdObj.isFromAirport = byTheHourStationAndAirport.isFromAirport;
        sfdObj.isToAirport = byTheHourStationAndAirport.isToAirport;
        sfdObj.isStationTransfer = byTheHourStationAndAirport.isStationTransfer;
        sfdObj.isFromStation = byTheHourStationAndAirport.isFromStation;
        sfdObj.isToStation = byTheHourStationAndAirport.isToStation;

        checkByTheHourFormAvailableVehicle(sfdObj);

        pushEventGTM({
          event: "search",
          search_term: "Search Available Vehicles",
        });
      }
    }
  };

  const debouncedSearchAvailableVehicles = debounce(
    searchAvailableVehicles,
    500
  );

  const setFormValidationValues = () => {
    let status = true;
    if (
      pickuplocation === undefined ||
      dropofflocations.length === 0 ||
      byTheHourFormData.traveldate === "" ||
      byTheHourFormData.pickuptime === "" ||
      getTotalPaxCount(byTheHourFormData.pax) === 0 ||
      byTheHourFormData.duration === "" ||
      !changeTravelArea ||
      changeLuggage === false
    )
      status = false;
    else status = true;
    setformDataValidation({
      pickuplocation: pickuplocation !== undefined ? true : false,
      dropofflocations: dropofflocations.length > 0 ? true : false,
      traveldate: byTheHourFormData.traveldate !== "" ? true : false,
      pickuptime: byTheHourFormData.pickuptime !== "" ? true : false,
      pax: getTotalPaxCount(byTheHourFormData.pax) > 0 ? true : false,
      duration: byTheHourFormData.duration !== "" ? true : false,
      travelArea: changeTravelArea ? true : false,
      luggage: changeLuggage === true ? true : false,
    });
    return status;
  };

  const setByTheHourForm = async () => {
    const byTheHourDataObj = {
      pickuplocation: pickuplocation,
      dropofflocations: dropofflocations,
      traveldate: byTheHourFormData.traveldate,
      pickuptime: byTheHourFormData.pickuptime,
      dropofftime: byTheHourFormData.dropofftime,
      pax: byTheHourFormData.pax,
      lugage: byTheHourFormData.lugage,
      duration: byTheHourFormData.duration,
      byTheHourBook: true,
      isAirportTransfer: byTheHourStationAndAirport.isAirportTransfer,
      isFromAirport: byTheHourStationAndAirport.isFromAirport,
      isToAirport: byTheHourStationAndAirport.isToAirport,
      isStationTransfer: byTheHourStationAndAirport.isStationTransfer,
      isFromStation: byTheHourStationAndAirport.isFromStation,
      isToStation: byTheHourStationAndAirport.isToStation,
      travelArea: byTheHourFormData.travelArea,
    };
    dispatch(addByTheHourFormToState(byTheHourDataObj));
    dispatch(addSingleDestinationFormToState(null));
    dispatch(addMultipleDestinationFormToState(null));
    dispatch(addAirportFormToState(null));
    // Get current language from i18next
    const currentLng = i18n.language || "jp";

    // Redirect to the localized version of /book
    // Ensure the leading slash is present to avoid relative path stacking
    history.push(`/${currentLng}/book`);
    // history.push("/book");
  };

  useEffect(() => {
    if (totalPax > 0) {
      handleChangeValidation("pax", true);
    }
  }, [totalPax]);

  const setTotalPaxValues = (formData) => {
    var summed = getTotalPaxCount(formData);
    setTotalPax(summed);
  };

  const setTotalLugageValues = (formData) => {
    var summed = getTotalLuggageCount(formData);
    setTotalLugage(summed);
  };

  const setPaxFormDataToState = (formData) => {
    var summedPax = getTotalPaxCount(formData);
    setTotalPax(summedPax);
    setByTheHourFormData({ ...byTheHourFormData, pax: formData });
  };

  const setLugageFormDataToState = (formData) => {
    setChangeLuggage(true);
    setformDataValidation({
      ...formDataValidation,
      luggage: true,
    });
    var summedLugage = getTotalLuggageCount(formData);
    setTotalLugage(summedLugage);
    setByTheHourFormData({ ...byTheHourFormData, lugage: formData });
  };

  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setPassangeVisible(false);
          setLugageVisible(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const checkIsAirportOrStation = (pickupLocation, dropoffLocations) => {
    const AIRPORT_KEYWORDS = ["airport", "空港"];
    const STATION_KEYWORDS = ["station", "駅"];

    const AIRPORT_NAMES = ["haneda", "羽田", "narita", "成田", "kansai", "関西", "itami", "伊丹", "chubu", "chubu centrair", "中部国際"];
    const STATION_NAMES = ["tokyo", "東京", "shinjuku", "新宿", "shinagawa", "品川"];

    const isMatchingPlace = (location, typeKeywords, nameKeywords) => {
      if (!location || !location.formatted_address || !location.types) return { isMatch: false, type: "none" };

      const typesLower = location.types.map(t => t.toLowerCase());
      const addressParts = location.formatted_address.toLowerCase().split(",");

      if (typesLower.includes("airport") || typesLower.includes("train_station") || typesLower.includes("subway_station")) {

        if (typesLower.includes("airport")) {
          return { isMatch: true, type: "airport" };
        } else {
          // Check for matching type and address parts
          for (let i = 0; i < addressParts.length; i++) {
            for (let keyword of typeKeywords) {
              for (let name of nameKeywords) {
                if (
                  addressParts[i].includes(name) &&
                  addressParts[i].includes(keyword)
                ) {
                  return { isMatch: true, type: "station" };
                }
              }
            }
          }
        }
      }

      // // Fallback: if location.types directly includes one of the types
      // if (typesLower.includes("airport")) return { isMatch: true, type: "airport" };
      // if (typesLower.includes("train_station") || typesLower.includes("subway_station")) return { isMatch: true, type: "station" };

      return { isMatch: false, type: "none" };
    };

    const pickup = isMatchingPlace(pickupLocation, [...AIRPORT_KEYWORDS, ...STATION_KEYWORDS], [...AIRPORT_NAMES, ...STATION_NAMES]);
    const dropoffLoc = dropoffLocations?.[dropoffLocations.length - 1];
    const dropoff = isMatchingPlace(dropoffLoc, [...AIRPORT_KEYWORDS, ...STATION_KEYWORDS], [...AIRPORT_NAMES, ...STATION_NAMES]);

    return {
      check: pickup.isMatch || dropoff.isMatch,
      pickupStatus: pickup.isMatch,
      dropoffStatus: dropoff.isMatch,
      pickupType: pickup.type,
      dropoffType: dropoff.type
    };
  };

  useEffect(() => {
    if (!pickuplocation && dropofflocations.length === 0) return;

    const { check, pickupStatus, dropoffStatus, dropoffType, pickupType } = checkIsAirportOrStation(
      pickuplocation,
      dropofflocations
    );

    if (check) {
      if (dropoffType === "airport" || pickupType === "airport" || dropoffType === "station" || pickupType === "station") {
        setByTheHourStationAndAirport(prev => ({
          ...prev,
          isAirportTransfer: dropoffType === "airport" || pickupType === "airport",
          isFromAirport: (pickupStatus && pickupType === "airport" ? true : false),
          isToAirport: (dropoffStatus && dropoffType === "airport" ? true : false),
          isStationTransfer: dropoffType === "station" || pickupType === "station",
          isFromStation: (pickupStatus && pickupType === "station" ? true : false),
          isToStation: (dropoffStatus && dropoffType === "station" ? true : false)
        }));
      }
    } else {
      setByTheHourStationAndAirport(prev => ({
        ...prev,
        isAirportTransfer: false,
        isFromAirport: false,
        isToAirport: false,
        isStationTransfer: false,
        isFromStation: false,
        isToStation: false
      }));
    }
  }, [pickuplocation, dropofflocations]);

  const pickupLocationSelected = async (place) => {
    setByTheHourFormData({
      ...byTheHourFormData,
      duration: "",
    });
    if (place === undefined) return;
    const level1 = place.address_components.find(c => c.types.includes("administrative_area_level_1"));

    const city = level1?.long_name || null;
    place.lat = place.geometry.location.lat;
    place.lon = place.geometry.location.lng;
    place.label = place.formatted_address;
    place.formatted_address = place.formatted_address;
    place.value = place.place_id;
    place.city = city;
    place.prefecture = city;
    setpickuplocation(place);
    handleChangeValidation("pickuplocation", true);
  };

  const dropOffLocationSelected = async (place) => {
    setByTheHourFormData({
      ...byTheHourFormData,
      duration: "",
    });
    if (place === undefined) return;
    const level1 = place.address_components.find(c => c.types.includes("administrative_area_level_1"));

    const city = level1?.long_name || null;
    place.lat = place.geometry.location.lat;
    place.lon = place.geometry.location.lng;
    place.label = place.formatted_address;
    place.formatted_address = place.formatted_address;
    place.value = place.place_id;
    place.city = city;
    place.prefecture = city;
    setdropofflocations([place]);

    handleChangeValidation("dropofflocations", true);
  };

  function populateDurationSelect(minimal_duration) {
    setHalfHourIntervalsData([]);
    const start_from = Math.round(minimal_duration / 30);
    const halfHourIntervals = Array.from({ length: 49 }, (_, i) => {
      const hours = Math.floor(i / 2);
      const minutes = (i % 2) * 30;
      const time = `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
      // No label here: it is built when the list renders (getDurationLabel),
      // so it follows the current language. A label stored now stayed in the
      // language the list was first built in.
      return { value: time };
    });
    const final_hour_data = halfHourIntervals.slice(start_from + 2);
    setHalfHourIntervalsData(final_hour_data);
  }

  /**
   * * If the user changes the airport selection dropdown list, this funtion will fire.
   * * Set state variables
   */
  const onChangeDuration = (e) => {
    setByTheHourFormData({ ...byTheHourFormData, duration: e.value });
    handleChangeValidation("duration", true);
  };

  const onChangeTravelArea = (e) => {
    setByTheHourFormData({
      ...byTheHourFormData,
      travelArea: e.value,
    });
    handleChangeValidation("travelArea", true);
    setChangeTravelArea(true);
  };

  /**
   * * Function to get minimal duration count by the selected pickuplocation and dropofflocation. Fire when both pickup and dropoff location is filled.
   * ? sfd - Selected Form Data
   * @param sfd
   */
  const checkTotalTime = async (sfd) => {
    availabilityValueReset();
    const start = sfd.pickuplocation.lat + "%2C" + sfd.pickuplocation.lon;
    const end =
      sfd.dropofflocations[0].lat + "%2C" + sfd.dropofflocations[0].lon;

    const car_r = await getRouteCarForTotalTime(start, end);

    const { total_time } = getSelectedRouteData(car_r);

    populateDurationSelect(total_time);
  };

  /**
   * * Get the selected route's data
   * @param total_time - return parameter - total time in minutes
   */
  const getSelectedRouteData = (car_r) => {
    const summary_arr = car_r[car_r.length - 1].summary;

    const total_time = summary_arr.move.time;

    return {
      total_time,
    };
  };

  /**
   * * Function to get minimal duration count by the selected pickuplocation and dropofflocation and paste to drop off time as final estimation dropoff time of customer. Fire when both pickup location, dropoff location, and pickup time is filled.
   * ? sfd - Selected Form Data
   * ? timeString - pickup time in string 'HH:MM'
   * @param sfd
   * @param timeString - not required
   */
  const estimateTimeToDestination = async (sfd, timeString) => {
    availabilityValueReset();
    const start = sfd.pickuplocation.lat + "%2C" + sfd.pickuplocation.lon;
    const end =
      sfd.dropofflocations[0].lat + "%2C" + sfd.dropofflocations[0].lon;

    const car_r = await getRouteCarForTotalTime(start, end);

    const { total_time } = getSelectedRouteData(car_r);

    const timeToAdd = timeString === undefined ? sfd.pickuptime : timeString;

    const [hours, minutes] = timeToAdd.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;
    const newTotalMinutes = (totalMinutes + total_time) % (24 * 60);
    const newHours = Math.floor(newTotalMinutes / 60);
    const newMinutes = newTotalMinutes % 60;

    setDropOffTimeToShow(
      `${String(newHours).padStart(2, "0")}:${String(newMinutes).padStart(2, "0")}`
    );
  };

  /**
   * * Function to get minimal duration count by the selected pickuplocation and dropofflocation and paste to drop off time as final estimation dropoff time of customer. Fire when both pickup location, dropoff location, and pickup time is filled.
   * ? sfd - Selected Form Data
   * ? timeString - pickup time in string 'HH:MM'
   * @param sfd
   * @param timeString - not required
   * @param duration - selected duration
   */
  const estimateTimeToDestinationWithDuration = async (sfd, timeString) => {
    availabilityValueReset();
    const timeToAdd = timeString === undefined ? sfd.pickuptime : timeString;
    const duration = sfd.duration;

    const [hours, minutes] = timeToAdd.split(":").map(Number);
    const [hoursDuration, minutesDuration] = duration.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;
    const totalDurations = hoursDuration * 60 + minutesDuration;
    const newTotalMinutes = (totalMinutes + totalDurations) % (24 * 60);
    const newHours = Math.floor(newTotalMinutes / 60);
    const newMinutes = newTotalMinutes % 60;

    setDropOffTimeToShow(
      `${String(newHours).padStart(2, "0")}:${String(newMinutes).padStart(
        2,
        "0"
      )}`
    );
  };

  useEffect(() => {
    if (
      byTheHourFormData.dropofflocations.length > 0 &&
      byTheHourFormData.pickuplocation &&
      byTheHourFormData.pickuptime !== "" &&
      byTheHourFormData.duration !== "" &&
      byTheHourFormData.traveldate !== ""
    ) {
      estimateTimeToDestinationWithDuration(byTheHourFormData);
    } else if (
      byTheHourFormData.dropofflocations.length > 0 &&
      byTheHourFormData.pickuplocation !== "" &&
      byTheHourFormData.pickuptime !== ""
    ) {
      estimateTimeToDestination(byTheHourFormData);
    }

    if (
      byTheHourFormData.dropofflocations.length > 0 &&
      byTheHourFormData.pickuplocation
    ) {
      checkTotalTime(byTheHourFormData);
    }
  }, [
    byTheHourFormData.dropofflocations,
    byTheHourFormData.pickuplocation,
    byTheHourFormData.pickuptime,
    byTheHourFormData.duration,
    byTheHourFormData.traveldate,
  ]);

  useEffect(() => {
    setByTheHourFormData({
      ...byTheHourFormData,
      pickuplocation: pickuplocation,
      dropofflocations: dropofflocations,
    });
  }, [pickuplocation, dropofflocations]);

  const handleChangeValidation = (key, condition) => {
    setformDataValidation((formDataValidation) => ({
      ...formDataValidation,
      [key]: condition,
    }));
  };

  /**
   * "02:30" -> "02 Hours 30 Minutes" / "02時間 30分", in the language the site
   * is showing right now. The one place a duration label is made, used by
   * both the option list and the selected value, so switching language
   * re-labels everything.
   */
  const getDurationLabel = (durationString) => {
    const [hours = "00", minutes = "00"] = (durationString || "").split(":");
    const paddedHours = hours.padStart(2, "0");
    const paddedMinutes = minutes.padStart(2, "0");
    const isEnglish = lang?.toUpperCase() === "EN";
    return isEnglish
      ? `${paddedHours} Hours ${paddedMinutes} Minutes`
      : `${paddedHours}時間 ${paddedMinutes}分`;
  };

  // The selected duration as a react-select option.
  const formatDuration = (durationString) => ({ value: durationString });

  const formatTravelArea = (travelArea) => {
    if (!travelArea) return;
    // Format the label
    var label;

    if (travelArea === "undecided") label = t("ByTheHour.TravelArea.Undecided");
    if (travelArea === "withinCity")
      label = t("ByTheHour.TravelArea.WithinCity");
    if (travelArea === "neighboringPerfecture")
      label = t("ByTheHour.TravelArea.NeighboringPerfecture");

    // Return the formatted object
    return { value: travelArea, label };
  };

  const handleChangeRaw = (date) => {
    //add collon after second number but make logic if user want to delete text
    if (date.length == 2 && date.includes(":") == false) {
      date = date + ":";
    } else if (date.length == 3 && date.includes(":") == true) {
      date = date.substring(0, date.length - 1);
    }
    if (
      date.length == 5 &&
      date.includes(":") &&
      date.split(":")[0] <= 24 &&
      date.split(":")[1] <= 60
    ) {
      if (date.split(":")[0] == 24 && date.split(":")[1] > 0) {
        handleChangeValidation("pickuptime", false);
      } else {
        handleChangeValidation("pickuptime", true);
      }
    } else {
      handleChangeValidation("pickuptime", false);
    }

    setByTheHourFormData({
      ...byTheHourFormData,
      pickuptime: date.isempty ? "" : date,
    });
  };

  return (
    <div className="bg-white p-3 p-md-3 card-form-custom">
      {/* FIRST LINE INPUT */}
      <div className="tw:grid tw:gap-3 tw:mb-3 tw:md:mb-8">
        {/* PICKUP ADDRESS */}
        <div className="col-12 input-box">
          <div className="form-floating position-relative">
            <CustomGoogleAutoComplete
              id="pickUpAddress"
              onPlaceSelected={pickupLocationSelected}
              defaultValue={
                pickuplocation?.formatted_address
                  ? pickuplocation?.formatted_address
                  : null
              }
              invalidText={"SpecifiedDestination.Pickup.Specific.Validation"}
              isInvalid={!formDataValidation.pickuplocation}
              placeholder="Pick-up address"
              ariaLabel="Pick-up address"
            />
            <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
              <div className="d-flex justify-content-center">
                <LocationPinIcon />
              </div>
            </span>
            <label htmlFor="floatingInput" className="label-icon">
              {t("Pick.Up.Address")}
            </label>
          </div>
        </div>

        {/* DROPOFF ADDRESS DESKTOP */}
        <div className="col-12 input-box">
          <div className="form-floating position-relative">
            <CustomGoogleAutoComplete
              id="dropoff1"
              onPlaceSelected={dropOffLocationSelected}
              defaultValue={
                byTheHourFormData?.dropofflocations[0]?.formatted_address !==
                  undefined
                  ? byTheHourFormData?.dropofflocations[0]?.formatted_address
                  : byTheHourForm?.dropofflocations[0]?.formatted_address !==
                    undefined
                    ? byTheHourForm?.dropofflocations[0]?.formatted_address
                    : null
              }
              invalidText={"SpecifiedDestination.Dropoff.Specific.Validation"}
              isInvalid={formDataValidation.dropofflocations ? false : true}
              placeholder="Drop-off address"
              ariaLabel="Drop-off address"
            />
            <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
              <div className="d-flex justify-content-center">
                <LocationPinIcon />
              </div>
            </span>
            <label htmlFor="floatingInput" className="label-icon">
              {t("Drop.Off.Address")}
            </label>
          </div>
        </div>

        {/* USAGE DURATION DESKTOP*/}
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 d-lg-block">
          <div className="form-floating">
            {byTheHourFormData?.duration !== "" ? (
              <Select
                // type="select"
                noOptionsMessage={() =>
                  t("booking_by_the_hour.select_duration")
                }
                name="duration"
                classNamePrefix="react-select-time"
                className={cn("tlf-select", !formDataValidation.duration && "invalid")}
                styles={{
                  control: (baseStyles, isActive) => ({
                    ...baseStyles,
                    paddingTop: "",
                    paddingLeft: "8px",
                    paddingBotton: "0.75rem",
                    border: "none",
                    borderBottom: "1px solid #DBBE78",
                    borderColor: "#dbbe78",
                    height: "50px",
                    borderRadius: "0.3rem",
                    background: "#ffffff",
                    fontSize: "14px",
                    color: byTheHourFormData.duration ? "#282828" : "",
                    fontWeight: byTheHourFormData.duration ? "bolder" : "",
                  }),
                }}
                autoComplete={BROWSER_AUTOFILL_OFF}
                placeholder={t("Usage Duration (e.g., 2 hours)")}
                value={
                  byTheHourFormData.duration != ""
                    ? formatDuration(byTheHourFormData?.duration)
                    : ""
                }
                onChange={(e) => {
                  onChangeDuration(e);
                  availabilityValueReset();
                }}
                options={halfHourIntervalsData}
                getOptionLabel={(option) => getDurationLabel(option.value)}
                components={{
                  DropdownIndicator: AnimatedSelectIndicator,
                  IndicatorSeparator: () => null,
                  Menu: AnimatedSelectMenu,
                  Option: LuxurySelectOption,
                }}
              />
            ) : (
              <Select
                noOptionsMessage={() =>
                  t("booking_by_the_hour.select_duration")
                }
                // type="select"
                name="duration"
                classNamePrefix="react-select-time"
                className={cn("tlf-select", !formDataValidation.duration && "invalid")}
                styles={{
                  control: (baseStyles, isActive) => ({
                    ...baseStyles,
                    paddingTop: "",
                    paddingLeft: "8px",
                    paddingBotton: "0.75rem",
                    border: "1px solid #F1F1F1",
                    height: "50px",
                    borderRadius: "0.3rem",
                    background: "#ffffff",
                    fontSize: "14px",
                  }),
                }}
                autoComplete={BROWSER_AUTOFILL_OFF}
                placeholder={t("Usage Duration (e.g., 2 hours)")}
                onChange={(e) => {
                  onChangeDuration(e);
                  availabilityValueReset();
                }}
                value=""
                options={halfHourIntervalsData}
                getOptionLabel={(option) => getDurationLabel(option.value)}
                components={{
                  DropdownIndicator: AnimatedSelectIndicator,
                  IndicatorSeparator: () => null,
                  Menu: AnimatedSelectMenu,
                  Option: LuxurySelectOption,
                }}
              />
            )}
            <FieldError show={!formDataValidation.duration}>{t("UsageDurationValidation")}</FieldError>
          </div>
        </div>
        {/* TRAVEL DATE */}
        <div className="tw:grid tw:grid-cols-2 tw:gap-3">
          <div className="tw:w-full">
            <AnimatedDatePicker
              locale={lang?.toUpperCase() === "EN" || lang?.toUpperCase() === "en" ? "en" : "ja"}
              selected={travelDatePicker}
              minDate={new Date()}
              onSelect={(date) => {
                var formatedDate = date.toLocaleDateString("sv-SE", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                });
                setTravelDatePicker(date);
                setFormatedTravelDate(formatedDate);
                availabilityValueReset();
                handleChangeValidation("traveldate", true);
                setByTheHourFormData({
                  ...byTheHourFormData,
                  traveldate: formatedDate,
                });
              }}
              customInput={
                <div className="form-floating position-relative">
                  <input
                    readOnly={true}
                    autoComplete={BROWSER_AUTOFILL_OFF}
                    type="text"
                    name="traveldate"
                    className={`tw:!h-[50px] ${formDataValidation.traveldate
                      ? "form-control form-control-icon"
                      : "form-control form-control-icon invalid"
                      }`}
                    style={{
                      borderColor: !formDataValidation.traveldate ? "red" : "",
                      color: byTheHourFormData.traveldate ? "#282828" : "",
                      fontWeight: byTheHourFormData.traveldate ? "bold" : "",
                    }}
                    placeholder="Travel date"
                    aria-label="Travel date"
                    defaultValue={
                      formatedTravelDate && typeof formatedTravelDate === 'string'
                        ? moment(formatedTravelDate, 'YYYY-MM-DD').format(dateFormat[lang])
                        : "" // Use an empty string if the date value is not set
                    }
                  />

                  <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                    <div className="d-flex justify-content-center">
                      <CalendarIcon color="#DBBE78" size={18} />
                    </div>
                  </span>
                  <label htmlFor="floatingInput" className="label-icon">
                    {t("Travel.Date")}
                  </label>
                </div>
              }
            />

            <FieldError show={formDataValidation.traveldate === false}>
              {t("SpecifiedDestination.TravelDate.Validation")}
            </FieldError>
          </div>

          {/* PICKUP TIME */}
          <div className="tw:w-full">
            <AnimatedDatePicker
              locale={lang?.toUpperCase() === "EN" || lang?.toUpperCase() === "en" ? "en" : "ja"}
              showTimeSelect
              showTimeSelectOnly
              selectedTime={byTheHourFormData.pickuptime}
              timeIntervals={5}
              timeCaption={t("Pick.Up.Time")}
              timeFormat="HH:mm"
              dateFormat="HH:mm"
              onChange={(date, event) => {
                if (event == undefined) {
                  var formatedDate = date.toLocaleDateString("sv-SE", {
                    hour: "2-digit",
                    minute: "2-digit",
                  });
                  var tge = moment(formatedDate);
                  setByTheHourFormData({
                    ...byTheHourFormData,
                    pickuptime: tge.format("HH:mm"),
                  });
                  handleChangeValidation("pickuptime", true);
                  availabilityValueReset();
                }
              }}
              onChangeRaw={(event) => handleChangeRaw(event.target.value)}
              customInput={
                <div className="form-floating position-relative">
                  <input
                    type="text"
                    name="pickuptime"
                    maxLength={5}
                    autoComplete={BROWSER_AUTOFILL_OFF}
                    style={{
                      borderColor: !formDataValidation.pickuptime ? "red" : "",
                      color: byTheHourFormData.pickuptime ? "#282828" : "",
                      fontWeight: byTheHourFormData.pickuptime ? "bold" : "",
                    }}
                    className={`tw:!h-[50px] ${formDataValidation.traveldate
                      ? "form-control form-control-icon"
                      : "form-control form-control-icon invalid"
                      }`}
                    placeholder="Pick-up time"
                    aria-label="Pick-up time"
                    value={byTheHourFormData?.pickuptime}
                  />

                  <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                    <div className="d-flex justify-content-center">
                      <ClockIcon />
                    </div>
                  </span>
                  <label htmlFor="floatingInput" className="label-icon">
                    {t("Pick.Up.Time")}
                  </label>
                </div>
              }
            />
            <FieldError show={formDataValidation.pickuptime === false}>
              {t("AirportTransfer.PickupTime.Required")}
            </FieldError>

            {dropOffTimeToShow && (
              <p className="mt-1 mb-0 p-0">
                <span style={{ color: "#A7A7A7", fontWeight: "400", fontSize: "14px" }}>
                  {t("ByTheHour.EstDropoffTime")}{" "}
                </span>
                <span style={{ color: "#A7A7A7", fontWeight: "700", fontSize: "14px" }}>
                  {dropOffTimeToShow}
                </span>
              </p>
            )}
          </div>
        </div>

        {/* PAX AND LUGAGE */}
        <div ref={wrapperRef} className="tw:grid tw:grid-cols-2 tw:gap-3">
          <div className="tw:w-full">
            <div className="form-floating position-relative">
              <input
                readOnly={true}
                onClick={() => {
                  setPassangeVisible(!passengerVisible);
                  setLugageVisible(false);
                }}
                style={{
                  borderColor: !formDataValidation.pax ? "red" : "",
                  color: totalPax > 0 ? "#282828" : "",
                  fontWeight: totalPax > 0 ? "bold" : "",
                }}
                name="pax"
                autoComplete={BROWSER_AUTOFILL_OFF}
                type="number"
                id="passengers"
                placeholder="Passengers"
                aria-label="Passengers"
                min={0}
                value={totalPax ?? 0}
                className={`tw:!h-[50px] ${formDataValidation.traveldate
                  ? "form-control form-control-icon"
                  : "form-control form-control-icon invalid"
                  }`}
              />

              <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                <div className="d-flex justify-content-center">
                  <PaxIcon />
                </div>
              </span>
              <label htmlFor="floatingInput" className="label-icon">
                {t("Passengers")}
              </label>
            </div>
            <FieldError show={formDataValidation.pax === false}>
              {t("SpecifiedDestination.Passenger.Validation")}
            </FieldError>
          </div>

          <div className="tw:w-full">
            <div className="form-floating position-relative">
              <input
                readOnly={true}
                onClick={() => {
                  setLugageVisible(!lugageVisible);
                  setPassangeVisible(false);
                }}
                name="lugage"
                autoComplete={BROWSER_AUTOFILL_OFF}
                style={{
                  color: totalLugage > 0 ? "#282828" : "",
                  fontWeight: totalLugage > 0 ? "bold" : "",
                }}
                type={
                  (formDataValidation.luggage == null &&
                    changeLuggage === false) ||
                    (formDataValidation.luggage === false &&
                      changeLuggage === false)
                    ? "text"
                    : "number"
                }
                placeholder="Lugages"
                aria-label="Lugages"
                min={0}
                value={
                  (formDataValidation.luggage == null &&
                    changeLuggage === false) ||
                    (formDataValidation.luggage === false &&
                      changeLuggage === false)
                    ? "-"
                    : totalLugage ?? 0
                }
                className={`tw:!h-[50px] ${formDataValidation.luggage ||
                  formDataValidation.luggage == null ||
                  changeLuggage === true
                  ? "form-control form-control-icon"
                  : "form-control form-control-icon invalid"
                  }`}
              />

              <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                <div className="d-flex justify-content-center">
                  <LuggageIcon />
                </div>
              </span>
              <AnimatePresence>
                {lugageVisible === true && (
                  <PassengerCard
                    setPaxPanel={setPaxAndLuggaePannalVisibility}
                    setFormDataToState={setLugageFormDataToState}
                    passengerFormData={byTheHourFormData.lugage}
                    passangerForm={false}
                    luggageForm={true}
                  />
                )}
              </AnimatePresence>
              <AnimatePresence>
                {passengerVisible === true && (
                  <PassengerCard
                    setPaxPanel={setPaxAndLuggaePannalVisibility}
                    setFormDataToState={setPaxFormDataToState}
                    passengerFormData={byTheHourFormData.pax}
                    passangerForm={true}
                    luggageForm={false}
                  />
                )}
              </AnimatePresence>
              <label className="label-icon">{t("Luggage")}</label>
            </div>
          </div>
        </div>

        {/* TRAVEL AREA DESKTOP */}
        <div className="col-12 d-lg-block d-none ">
          <div>
            <Select
              placeholder={t("ByTheHour.TravelArea.Title")}
              classNamePrefix="react-select-travel-area"
              className={cn(
                "tlf-select",
                !(formDataValidation.travelArea == null || formDataValidation.travelArea) && "invalid"
              )}
              styles={{
                control: (baseStyles, isActive) => ({
                  ...baseStyles,
                  paddingTop: "",
                  paddingLeft: "8px",
                  paddingBotton: "0.75rem",
                  border: "1px solid #F1F1F1",
                  height: "50px",
                  borderRadius: "0.3rem",
                  background: "#ffffff",
                  fontSize: "14px",
                }),
              }}
              autoComplete={BROWSER_AUTOFILL_OFF}
              onChange={(e) => {
                // onChangeAirport(e);
                onChangeTravelArea(e);
                availabilityValueReset();
              }}
              value={formatTravelArea(byTheHourFormData?.travelArea)}
              getOptionLabel={(option) => t(option.label)}
              options={travelAreaOptions}
              components={{
                DropdownIndicator: AnimatedSelectIndicator,
                IndicatorSeparator: () => null,
                Menu: AnimatedSelectMenu,
                Option: LuxurySelectOption,
              }}
            // defaultValue={airportTypeOptions[0]}
            />
          </div>
        </div>
      </div>

      <div className="row g-3 tw:mb-5 tw:md:mb-0 tw:block tw:md:!hidden">
        {/* TRAVEL AREA & AIRPORT TRANSFER DESKTOP */}
        {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12 d-none">
          <div className="d-flex gap-3">
            <div className="d-flex align-items-center px-2 d-inline">
              <i className="pe-2 pb-1">
                <img alt="img" src={depature_flight_icon} />
              </i>
              <div className="pe-4">
                <label className="noto ">
                  {t("ByTheHour.FlightTrackingRequest.Title")}
                </label>
              </div>

              <div className="form-check pe-3">
                <input
                  disabled={dropofflocations.length > 1 ? true : false}
                  className={
                    formDataValidation.flightTracking == null ||
                    formDataValidation.flightTracking
                      ? "form-check-input"
                      : "form-check-input invalid"
                  }
                  type="radio"
                  name="flightTracking"
                  id="flexRadioDefault1"
                  onChange={onChangeFlightTracking}
                  value={true}
                  checked={changeFlightTracking && flightTracking === true}
                />
                <label
                  className="form-check-label noto"
                  htmlFor="flexRadioDefault1"
                >
                  {t("Yes")}
                </label>
              </div>

              <div className="form-check pe-3">
                <input
                  className={
                    formDataValidation.flightTracking == null ||
                    formDataValidation.flightTracking
                      ? "form-check-input"
                      : "form-check-input invalid"
                  }
                  type="radio"
                  name="flightTracking"
                  id="flexRadioDefault2"
                  onChange={onChangeFlightTracking}
                  value={false}
                  checked={changeFlightTracking && flightTracking === false}
                  disabled={isDisabledWithoutFlightTracking}
                />
                <label
                  className="form-check-label noto"
                  htmlFor="flexRadioDefault2"
                >
                  {t("No")}
                </label>
              </div>
            </div>
          </div>
          {formDataValidation.flightTracking == null ||
          formDataValidation.flightTracking ? (
            ""
          ) : (
            <p className="text-danger pb-2">
              {t("ByTheHour.TravelArea.Validation")}
            </p>
          )}
        </div> */}

        {/* TRAVEL AREA MOBILE */}
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 d-lg-none d-sm-block">
          <div>
            <Select
              placeholder={t("ByTheHour.TravelArea.Title")}
              classNamePrefix="react-select-travel-area"
              className={cn(
                "tlf-select",
                !(formDataValidation.travelArea == null || formDataValidation.travelArea) && "invalid"
              )}
              styles={{
                control: (baseStyles, isActive) => ({
                  ...baseStyles,
                  paddingTop: "",
                  paddingLeft: "8px",
                  paddingBotton: "0.75rem",
                  border: "1px solid #F1F1F1",
                  height: "50px",
                  borderRadius: "0.3rem",
                  background: "#ffffff",
                  fontSize: "14px",
                }),
              }}
              autoComplete={BROWSER_AUTOFILL_OFF}
              onChange={(e) => {
                // onChangeAirport(e);
                onChangeTravelArea(e);
                availabilityValueReset();
              }}
              getOptionLabel={(option) => t(option.label)}
              value={formatTravelArea(byTheHourFormData?.travelArea)}
              options={travelAreaOptions}
              components={{
                DropdownIndicator: AnimatedSelectIndicator,
                IndicatorSeparator: () => null,
                Menu: AnimatedSelectMenu,
                Option: LuxurySelectOption,
              }}
            // defaultValue={airportTypeOptions[0]}
            />
          </div>
        </div>
      </div>

      {/* FOURTH LINE INPUT */}
      <div className="d-grid ">
        <motion.button
          disabled={isLoading}
          type="button"
          {...searchButtonMotionProps(isLoading, shouldReduceMotion)}
          className="btn btn-primary btn-sm rounded-3  d-flex justify-content-center px-md-5 tw:h-[50px]"
          onClick={debouncedSearchAvailableVehicles}
        >
          <div className="d-flex align-items-center px-2 d-inline text-white tw:text-base tw:font-hanken-grotesk tw:font-medium tw:w-full tw:justify-center">
            <ButtonLoadingSwap
              isLoading={isLoading}
              spinner={
                <div className="spinner-border tw:text-white" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              }
            >
              <div className="tw:flex tw:items-center tw:gap-[10px]">
                {t("Search.Available.Vehicles")}
                <i className="">
                  <ArrowRightIcon color="#FFFFFF" size={24} />
                </i>
              </div>
            </ButtonLoadingSwap>
          </div>
        </motion.button>
      </div>
    </div>
  );
};

export default ByTheHourForm;
